import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../../baseComponents/AppsStyleDecider'
import SellOrderStatusBar, { SellOrderStatusBarNew, SellOrderStatusBarProps } from '../../../SellOrderStatusBar'
import SellOrderFinishedStepButtons, { SellOrderFinishedStepButtonsNew, SellOrderFinishedStepButtonsProps } from '../SellOrderFinishedStepButtons'

type SellOrderFinishedStepHeaderProps = & SellOrderStatusBarProps & SellOrderFinishedStepButtonsProps

const SellOrderFinishedStepHeaderDecider: React.FC<SellOrderFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={SellOrderFinishedStepHeaderDefault} NewComponent={SellOrderFinishedStepHeaderNew} {...rest} />
    )
}

const SellOrderFinishedStepHeaderDefault: React.FC<SellOrderFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellOrderStatusBar {...rest} />
            <SellOrderFinishedStepButtons {...rest} />
        </div>
    )
}

const SellOrderFinishedStepHeaderNew: React.FC<SellOrderFinishedStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <SellOrderStatusBarNew {...rest} />
            <SellOrderFinishedStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default SellOrderFinishedStepHeaderDecider